import { toast } from "react-toastify";
const toastOptions = {
  position: "top-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};
let toastCooldown = false;
export function handleApiError(err) {
  if (toastCooldown) {
    console.log("Skipping toast due to cooldown");
    return true;
  }

  toastCooldown = true;
  setTimeout(() => (toastCooldown = false), 3000);

  if (err.response?.status === 429) {
    toast.warning(err.response.data?.error || "Too many requests", {
      position: "top-right",
      autoClose: 4000,
      theme: "colored",
    });
    return true; // signal handled
  }

  if (!window.navigator.onLine) {
    toast.error(
      "No internet connection. Please check your network and try again.",
      toastOptions
    );
    return true;
  }

  toast.error(
     err?.message || "Sorry, something went wrong. Please try again later.",
    toastOptions
  );
  return true;
}
